module.exports = __webpack_public_path__ + "img/1.a533686a.jpg";